var map = {
	"./atmire/app/item-page/simple/field-components/specific-field/author/item-page-author-field.component": [
		"eYa+",
		53
	],
	"./custom/app/item-page/simple/field-components/specific-field/author/item-page-author-field.component": [
		"rzTK",
		113
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "LE+v";
module.exports = webpackAsyncContext;